import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { sqaContent } from '../models/recover-by-security-questions.interface';

export const recoverBySQAAttributesMock: sqaContent = {
  formGroup: new UntypedFormGroup({
    answer1: new UntypedFormControl('answer1'),
    answer2: new UntypedFormControl('answer2')
  }),
  sqaFormAttributes: {
    errorCount: 0,
    submitAttempt: false,
    errorAlertBanner: false,
    answer1ControlTouched: false,
    answer2ControlTouched: false
  },
  sqaStoredQuestionList: {
    errors: [
      {
        code: '21'
      }
    ],
    securityQuestionList: [
      {
        currentIndicator: 'Y',
        questionNumber: '17',
        questionText: "What is your father's middle name?"
      },
      {
        currentIndicator: 'Y',
        questionNumber: '18',
        questionText: 'What is the name of your childhood best friend?'
      }
    ],
    formNameSubmitted: 'resetPassword'
  },
  pageContent: {
    pageHeader: {
      altText: 'logo',
      logoUrl:
        'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
      headerTitle: 'Security Questions',
      headerSubTitle: ''
    },
    errors: {
      answer1ErrorMessage: 'Login Credential is incorrect. Please try again.',
      answer2ErrorMessage: 'Login Credential is incorrect. Please try again.',
      alertWarningErrorMessages: 'To continue, please correct the',
      formAlertErrorMessage: ''
    },
    answer1Label: 'Answer 1',
    answer1Text: 'Answer 1',
    answer2Label: 'Answer 2',
    answer2Text: 'Answer 2',
    contentBodyHeader: '',
    defaultSelectValue: 'Select One',
    headerSubTitle: '',
    headerTitle: 'Security Questions',
    nextDisplayView: {
      button_continue: '',
      button_createPassword: '',
      button_forgotPassword: '',
      button_loginHelp: '',
      button_modal: 'Continue',
      button_resetPassword: '',
      button_sendLogin: '',
      button_wfp: '',
      nextViewName: 'setPassword',
      nextViewName_createPassword: '',
      nextViewName_email: '',
      nextViewName_forgotPassword: '',
      nextViewName_loginHelp: '',
      nextViewName_resetPassword: '',
      nextViewName_sendLogin: '',
      nextViewName_sqa: '',
      overlayMessage: '',
      refreshUrl: ''
    },
    question1Label: 'Question 1',
    question2Label: 'Question 2',
    viewName: 'securityQuestionAnswers'
  },
  disableButton: false
};
